import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import NoTableData from "components/NoTableData";
import { formatDate } from "helpers/DateHelper";

const DeviceRowDHR = ({ tableData, hideVendors }) => {
  if (tableData.length) {
    return tableData.map((row, i) => {
      const { id, modelnumber, name, completedat } = row;
      return (
        <tr key={i}>
          {hideVendors ? null : <td>{name}</td>}
          <td>
            <Link to={`/dhr/devices/${id}`} className="glow-link">
              {modelnumber}
            </Link>
          </td>
          <td>{formatDate(completedat)}</td>
        </tr>
      );
    });
  }

  return <NoTableData colSpan={hideVendors ? 2 : 3} />;
};

DeviceRowDHR.propTypes = {
  tableData: PropTypes.array
};

export default DeviceRowDHR;
